import {mapGetters} from "vuex";

export const WithFormLabels = {
    computed: {
        ...mapGetters('ClaimForm', {claim_form: 'claim_form'}),
        formTitleLabel() {
            /** #3656 - cifrotech */
            if (this.claim_form.fixed_client !== null && this.claim_form.fixed_client.toUpperCase() === 'CIFROTECH') {
                return this.$t('form.steps.device_details.title_cifrotech');
            }
            return this.$t('form.steps.device_details.title');
        }
    }
}